import { useMemo } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonStylesV2, useLoaderStyles } from './styles';
import { VARIENT } from './constant';

const useStyles = makeStyles(ButtonStylesV2({}));

export const PPButton = ({
  id,
  reference,
  onClick: handleClick = () => {},
  label = '',
  type = 'button',
  color = 'primary',
  variant = VARIENT.contained,
  disabled = false,
  loading = false,
  startIcon,
  endIcon,
  startGutter = false,
  endGutter = false,
}) => {
  const classes = useStyles();
  const loaderClasses = useLoaderStyles();

  const ButtonStyle = new Map([
    [VARIENT.contained, classes.buttonStyle],
    [VARIENT.noOutlinedButtonStyle, classes.noOutlinedButtonStyle],
  ]);

  const _disabled = useMemo(() => (disabled || loading), [disabled, loading]);

  const Content = new Map([
    [false, label],
    [true, <CircularProgress className={loaderClasses.default} size={20} thickness={4} />]
  ]);

  return (
    <Button
      id={id}
      ref={reference}
      className={`${ButtonStyle.get(variant)} ${startGutter && classes.startGutter} ${endGutter && classes.endGutter}`}
      type={type}
      color={color}
      onClick={handleClick}
      disabled={_disabled}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {Content.get(loading)}
    </Button>
  );
};

export default PPButton;
